<template>
  <div id="app">
    <ShoppingCart />
  </div>
</template>

<script>
import ShoppingCart from './views/ShoppingCart.vue';

export default {
  name: 'App',
  components: {
    ShoppingCart,
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

body {
  margin: 0;
}


</style>
